import React from "react";

const FeatureTextSection = ({ 
  title, 
  description, 
  minisubline, 
  subline, 
  color = "text-[#ff6b35]", 
  className = "" 
}) => {
  return (
    <div className={`text-center py-16 ${className}`}>
      <div className="max-w-4xl mx-auto px-6">
        {minisubline && (
          <p className={`text-lg font-semibold mb-4 ${color}`}>
            {minisubline}
          </p>
        )}
        {title && (
          <h2 className="text-4xl md:text-5xl font-bold text-heading mb-6">
            {title}
          </h2>
        )}
        {subline && (
          <p className="text-xl font-medium text-gray-600 mb-6">
            {subline}
          </p>
        )}
        {description && (
          <p className="text-lg text-gray-700 leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default FeatureTextSection;
